import {Inertia} from "@inertiajs/inertia";

require('./bootstrap');

import '@lottiefiles/lottie-player'
import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import VueSmoothScroll from 'vue3-smooth-scroll'
import VueTouchScroll from 'vue-touch-scroll'
import Unicon from 'vue-unicons'

import {
    uniEye,
    uniUsersAlt,
    uniAnchor,
    uniLightbulbAlt,
    uniFlask,
    uniAtom,
    uniCornerUpLeftAlt,
    uniImages,
    uniMap,
    uniShop,
    uniShoppingBag,
    uniComments,
    uniUserCircle,
    uniServers,
    uniRobot,
    uniClipboardAlt,
    uniUserArrows,
    uniAngleLeft,
    uniCommentsAlt, uniShieldCheck, uniBracketsCurly
} from 'vue-unicons/dist/icons'

Unicon.add([
    uniEye,
    uniUsersAlt,
    uniAnchor,
    uniLightbulbAlt,
    uniAngleLeft,
    uniFlask,
    uniUserArrows,
    uniAtom,
    uniCornerUpLeftAlt,
    uniImages,
    uniMap,
    uniShop,
    uniShoppingBag,
    uniComments,
    uniUserCircle,
    uniServers,
    uniRobot,
    uniClipboardAlt,
    uniCommentsAlt,
    uniShieldCheck,
    uniBracketsCurly
])

InertiaProgress.init({
    color: '#433edc',
    delay: 0
})

Inertia.on('navigate', (event) => {
    window.dataLayer.push({
        'url': event.detail.page.url,
        'event': 'pageview'
    })
})

createInertiaApp({
    resolve: (name) => import(`./Pages/${name}`),
    setup({ el, app, props, plugin }) {
        const instance = createApp({ render: () => h(app, props) })
            .use(plugin)
            .use(Unicon)
            .use(VueTouchScroll)
            .use(VueSmoothScroll, {
                duration: 400,
                updateHistory: false
            })
            .mixin({
                methods: {
                    __: (key) => {
                        return window.translations[key] ?? key;
                    },
                    route,
                    getLocale: function() {
                        return window.currentLocale
                    }
                }
            });

        ['fr', 'en', 'jp'].map(locale => {
            instance.directive(locale, {
                beforeMount(el, binding) {
                    if (window.currentLocale !== locale) {
                        el.style.display = 'none'
                    }
                }
            })
        })
        instance.mount(el)
    },
})

/*Vue.use(Unicon)
Vue.use(VueScrollTo)
Vue.use(plugin)
Vue.use(VueTouchScroll)
-
const el = document.getElementById('app')

new Vue({
    render: h => h(App, {
        props: {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: name => require(`./Pages/${name}`).default,
            resolveErrors: page => (page.props.errors || {}),
        },
    }),
}).$mount(el)*/
